export const url = 'https://api.epos.tdrsoftware.in'; // production
// export const url = 'http://localhost:3000'; 

// export const url = 'https://api.dev.epos.tdrsoftware.in'; // development